"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var subscribtion_service_1 = require("./../../../Services/subscribtion.service");
var WickedApiClient_1 = require("./../../api/WickedApiClient");
var service_service_1 = require("src/app/Services/service.service");
var advertisement_service_1 = require("./../../../Services/advertisement.service");
var premium_ad_token_paymen_component_1 = require("./../../../Components/premium-ad-token/premium-ad-token-paymen.component");
var router_1 = require("@angular/router");
var AddWritterView;
(function (AddWritterView) {
    AddWritterView[AddWritterView["Loading"] = 0] = "Loading";
    AddWritterView[AddWritterView["FormAndPayment"] = 1] = "FormAndPayment";
    AddWritterView[AddWritterView["SendInformationCompleted"] = 3] = "SendInformationCompleted";
})(AddWritterView || (AddWritterView = {}));
var MobileAdWritterComponent = /** @class */ (function () {
    function MobileAdWritterComponent(formBuilder, subscriptionService, mainService, advertisementService, router) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.subscriptionService = subscriptionService;
        this.mainService = mainService;
        this.advertisementService = advertisementService;
        this.router = router;
        this.enableLetOurPros = false;
        this.gender = ["Male", "Female", "Transgender"];
        this.race = ["Arab", "Asian", "Black / Afro-American", "Hispanic", "Indian", "Mixed", "White / Caucasian"];
        this.view = AddWritterView.FormAndPayment;
        this.loading = false;
        this.canSubmit = false;
        this.blockSubmit = true;
        this.enableLetOurPros = mainService.enableLetOurPros;
        if (!this.enableLetOurPros) {
            this.router.navigate(['']);
        }
        this.dataForm = this.formBuilder.group({
            name: [''],
            age: [''],
            gender: [''],
            lookingFor: [''],
            height: [''],
            weight: [''],
            bodyType: [''],
            race: [''],
            idealMatch: [''],
            lookingForRelationship: [''],
            thingsInFreeTime: [''],
            aspectsOfLife: [''],
            dontLike: [''],
            passions: [''],
            occupation: [''],
            characteristics: [''],
            goalsAndDreams: [''],
            thankfullFor: [''],
            kids: [''],
            education: [''],
            workout: [''],
            travel: [''],
            healthyFood: [''],
            smoke: [''],
            alcohol: [''],
            email: [''],
            termsAndConditions: ['', [forms_1.Validators.required]],
        });
        this.dataForm.controls["termsAndConditions"].valueChanges.subscribe(function () {
            _this.blockSubmit = !_this.dataForm.controls["termsAndConditions"].value;
        });
    }
    MobileAdWritterComponent.prototype.ngOnInit = function () {
    };
    MobileAdWritterComponent.prototype.onTokenAdded = function (response) {
        var _this = this;
        if (response.isError) {
            this.mainService.showError(response.message ? response.message : "Your payment could not be processed, please contact your bank for details.");
            this.loading = false;
        }
        else {
            var data = new WickedApiClient_1.AdWritterInformationRequest({
                name: this.dataForm.controls["name"].value,
                age: this.dataForm.controls["age"].value,
                gender: this.dataForm.controls["gender"].value,
                lookingFor: this.dataForm.controls["lookingFor"].value,
                height: this.dataForm.controls["height"].value,
                weight: this.dataForm.controls["weight"].value,
                bodyType: this.dataForm.controls["bodyType"].value,
                race: this.dataForm.controls["race"].value,
                idealMatch: this.dataForm.controls["idealMatch"].value,
                lookingForRelationship: this.dataForm.controls["lookingForRelationship"].value,
                thingsInFreeTime: this.dataForm.controls["thingsInFreeTime"].value,
                aspectsOfLife: this.dataForm.controls["aspectsOfLife"].value,
                dontLike: this.dataForm.controls["dontLike"].value,
                passions: this.dataForm.controls["passions"].value,
                occupation: this.dataForm.controls["occupation"].value,
                characteristics: this.dataForm.controls["characteristics"].value,
                goalsAndDreams: this.dataForm.controls["goalsAndDreams"].value,
                thankfullFor: this.dataForm.controls["thankfullFor"].value,
                kids: this.dataForm.controls["kids"].value,
                education: this.dataForm.controls["education"].value,
                workout: this.dataForm.controls["workout"].value,
                travel: this.dataForm.controls["travel"].value,
                healthyFood: this.dataForm.controls["healthyFood"].value,
                smoke: this.dataForm.controls["smoke"].value,
                alcohol: this.dataForm.controls["alcohol"].value,
                email: this.dataForm.controls["email"].value,
            });
            this.advertisementService.CreateAdWriteInformation(data).then(function (response) {
                if (response.isSend) {
                    _this.view = AddWritterView.SendInformationCompleted;
                    _this.canSubmit = false;
                }
                else {
                    _this.mainService.showError(response.error);
                }
                _this.loading = false;
            }).catch(function () {
                console.log('Error with sending email');
                _this.mainService.showError("Error with sending email, please contact with us.");
            });
        }
    };
    MobileAdWritterComponent.prototype.onSubmit = function () {
        if (!this.dataForm.valid || !this.addTokenPayment.form.valid) {
            return;
        }
        this.loading = true;
        this.addTokenPayment.onSubmit();
    };
    return MobileAdWritterComponent;
}());
exports.MobileAdWritterComponent = MobileAdWritterComponent;
